<div class="image-control-wrapper">
  @if (!(previewNotSupported$ | async)) {
    @if (imageSource) {
      <div class="uploaded-image-container">
        <img class="uploaded-image" (load)="onLoaded()" #preview [src]="imageSource | stringSanitizer" />
      </div>
    }
  } @else {
    <span class="status-message">
      <i [nimbusIcon]="icons.INFO_CIRCLE_NEW"></i>
      <span>
        {{ TranslationKeys.ManageWorkflowPlaylistWmaPreviewNotSupported | translate }}
      </span>
    </span>
  }

  <mat-form-field appearance="outline" [color]="isWarning ? 'warn' : isDisabled ? 'locked' : null">
    <mat-label>
      @if (teamStatusIcon) {
        <span class="teams-status-icon" [ngClass]="teamStatusIcon" role="img"></span>
      }
      {{ label }}
    </mat-label>
    <input
      matInput
      [placeholder]="placeholder"
      readonly
      [errorStateMatcher]="this"
      [formControl]="textControl"
      [disabled]="isDisabled"
      [required]="isRequiredControl"
      spellcheck="false"
      autocomplete="off"
    />
    <ng-container matSuffix>
      <ng-content></ng-content>
    </ng-container>
    @if (isDisabled) {
      <i matSuffix [nimbusIcon]="icons.LOCK_LIGHT"></i>
    }
    @if (!isDisabled && !imageSource) {
      <i matSuffix class="upload-icon" [nimbusIcon]="icons.UPLOAD" (click)="openFileDialog()"></i>
    }
    @if (!isDisabled && imageSource) {
      <i matSuffix class="remove-icon" [nimbusIcon]="icons.TRASH_LIGHT" (click)="remove()"></i>
    }
    @if (ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid) {
      <mat-error>
        <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="error-triangle"></i>
        <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
      </mat-error>
    }
    @if (imageSource) {
      <mat-hint align="end">{{ previewDimension$ | async }}</mat-hint>
    }
  </mat-form-field>
</div>
